import { Icon } from '../../../common/view/icon/icon';
import { GapY } from '../../../foundation/layout/gap-y';
import { StackY } from '../../../foundation/layout/stack-y';
import { TripleX } from '../../../foundation/layout/triple-x';
import { EffectMenuItemStyle } from './effect-menu-item.style';

export function EffectMenuItem({
  icon,
  iconColor,
  title,
  subtitle,
  onClick,
}: {
  icon: any;
  iconColor: string;
  title: string;
  subtitle: string;
  onClick?: () => void;
}) {
  return (
    <EffectMenuItemStyle.Container onClick={onClick}>
      <TripleX.Container $gap={'12px'} $align={'center'}>
        <TripleX.Side>
          <EffectMenuItemStyle.IconContainer style={{ background: iconColor }}>
            <Icon icon={icon} color={'#000000'} size={'32px'} />
          </EffectMenuItemStyle.IconContainer>
        </TripleX.Side>
        <TripleX.Rest>
          <StackY>
            <EffectMenuItemStyle.Title>{title}</EffectMenuItemStyle.Title>
            <GapY $gap="6px" />
            <EffectMenuItemStyle.Subtitle>{subtitle}</EffectMenuItemStyle.Subtitle>
          </StackY>
        </TripleX.Rest>
      </TripleX.Container>
    </EffectMenuItemStyle.Container>
  );
}
